export * from "./util/index";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/misc/index.js
// module id = 474
// module chunks = 0